






















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import GlobalMixins from '../mixins';
import { IResult, IStatement, IPartyStatement } from '@/interfaces';
import StatementTitle from '@/components/StatementTitle.vue'
import AppError from '@/components/AppError.vue'
import AppNav from "@/components/AppNav.vue";

@Component({
	components: {
		StatementTitle,
		AppError,
        AppNav
	}
})
export default class ChoicesOverview extends GlobalMixins {
	@Prop({ required: true }) selectedResult!: IResult
	@Prop({ required: true }) footerResults!: IResult[]

	titleOpen: number[] = []
	showTooMuchSkippedError: boolean = false
	disableChoicebuttons: boolean = false
	explanationsOpen: number[] = []
	animatingPartyWrapper: boolean = false
	resultsOnLoad: string = ''
	partyWrapperWidth: number = 0
	isMounted: boolean = false
	updateResults: number = 0

	get statementsWithChoices() {
		this.updateCounter
		
		const userChoices = this.user.choices
		const statementsWithChoices = this.statements.map((statement: IStatement) => {
			const userChoice = userChoices.filter(userStatement => (userStatement.originalStatementId === statement.id))[0].choice
			const selectedPartyStatement = (this.selectedResult.party.statements as IPartyStatement[]).filter(partyStatement => (partyStatement.id === statement.id))[0]

			return {
				id: statement.id,
				theme: statement.theme,
				title: statement.title,
				userChoice,
				partyDetails: {
					position: selectedPartyStatement.position,
					explanation: selectedPartyStatement.explanation,
					accessibility: {
						explanation: selectedPartyStatement.accessibility.explanation ? selectedPartyStatement.accessibility.explanation : selectedPartyStatement.explanation
					}
				}
			}
		})

		return statementsWithChoices
	}
	get resultsChanged(): boolean {
		return !(JSON.stringify(this.footerResults) === this.resultsOnLoad)
	}
	get showArrows(): boolean {
		if (!this.isMounted) return false

		const partyWrapper = (this.$refs['party-wrapper'] as any).$el
		const partiesWidth = [...partyWrapper.querySelectorAll('.footer__party')]
			.reduce((total: number, party: any) => {
				return total + party.offsetWidth
			}, 0)
		let partyWrapperWidth = this.partyWrapperWidth

		if (partyWrapper.parentNode.querySelector('.footer__navigation-buttons')) {
			partyWrapperWidth += partyWrapper.parentNode.querySelector('.footer__navigation-buttons').offsetWidth
		}

		return (partyWrapperWidth < partiesWidth)
	}

	recordChoice(choice: 'agree' | 'neither' | 'disagree' | 'skip', statementIndex: number, statementId: number) {
		if (choice === 'skip' && ((this.amountSkipped - 1) < (this.statements.length / 2))) {
			this.showTooMuchSkippedError = true
			return
		}
		if (this.disableChoicebuttons) return

		const previousChoiceOfStatement = this.statementsWithChoices.filter((statement, index) => index === statementIndex)[0].userChoice

		if (previousChoiceOfStatement === choice) return

		this.disableChoicebuttons = true

		this.$store.dispatch('setStatementChoice', {
			choice,
			statement: (statementIndex + 1),
			originalStatementId: statementId
		})

		if (choice === 'skip') {
			this.$store.dispatch('removeFromPriorityStatements', statementId)
		}

		this.$emit('updateResults')

		this.updateCounter++
		this.disableChoicebuttons = false
	}
	toResults(): void {
		this.$emit('closeOverview')
	}
	matchesSelectedResult(result: IResult) {
		return (JSON.stringify(result.party) === JSON.stringify(this.selectedResult.party))
	}
	selectParty(result: IResult): void {
		this.explanationsOpen = []

		this.$emit('selectParty', result);

		(document.querySelector(".skip-link") as HTMLElement)?.focus();
	}
	toggleExplanation(index: number) {
		if (this.explanationsOpen.indexOf(index) === -1) {
			this.explanationsOpen.push(index)
		} else {
			this.explanationsOpen.splice(this.explanationsOpen.indexOf(index), 1)
		}
	}
	scrollPartyWrapper(direction: 'left' | 'right'): void {
		if (this.animatingPartyWrapper) return

		this.animatingPartyWrapper = true

		const partyWrapper = (this.$refs['party-wrapper'] as Vue).$el
		const distance = direction === 'left' ? -240 : 240
		let timePast = 0
		const timer = setInterval(() => {
			partyWrapper.scrollLeft += (distance / 15)

			timePast += 10

			if (timePast === 150) {
				this.animatingPartyWrapper = false

				clearInterval(timer)
			}
		}, 10)
	}

	created() {
		document.addEventListener('keydown', e => {
			if (e.code === 'Escape' && !this.titleOpen.length) {
				if (this.showTooMuchSkippedError) {
					this.showTooMuchSkippedError = false
				} else {
					this.toResults()
				}
			}
		})		

		this.resultsOnLoad = JSON.stringify(this.footerResults)
	}
	mounted() {
		this.isMounted = true

		window.addEventListener('resize', () => {
			if (!this.$refs['party-wrapper']) return

			this.partyWrapperWidth = (this.$refs['party-wrapper'] as any).$el.offsetWidth
		})
		this.partyWrapperWidth = (this.$refs['party-wrapper'] as any).$el.offsetWidth
	}
}
